/**
 * Shared constants for the TGA module
 */

/**
 * NDVI (Normalized Difference Vegetation Index) gradient used in satellite imagery visualization.
 * Maps from low vegetation (yellow #fdfa72) to high vegetation (green #195432)
 */
export const NDVI_GRADIENT = 'linear-gradient(to right, #fdfa72, #195432)';
